/**
 * Données mock utilisées si le backend est indisponible.
 * Permet au frontend de fonctionner en mode démo standalone.
 */

export const MOCK_USER_ADMIN = {
  id: 1,
  email: "admin@monministere.com",
  full_name: "Pasteur Emmanuel Koffi",
  role: "pasteur",
  eglise_id: 1,
  member_id: null,
  is_active: true,
};

export const MOCK_USER_FIDELE = {
  id: 2,
  email: "fidele@monministere.com",
  full_name: "Aïcha Bamba",
  role: "fidele",
  eglise_id: 1,
  member_id: 1,
  is_active: true,
};

/** Cellules mock — utilisées en fallback si le backend est injoignable. */
export const MOCK_CELLULES = [
  { id: 1, nom: "Cellule Cocody",    description: null, eglise_id: 1, eglise_nom: "Église Grâce Abidjan", responsable_id: null, responsable_nom: null, is_active: true, nb_membres: 2 },
  { id: 2, nom: "Cellule Riviera",   description: null, eglise_id: 1, eglise_nom: "Église Grâce Abidjan", responsable_id: null, responsable_nom: null, is_active: true, nb_membres: 1 },
  { id: 3, nom: "Cellule Mermoz",    description: null, eglise_id: 2, eglise_nom: "Église Grâce Dakar",   responsable_id: null, responsable_nom: null, is_active: true, nb_membres: 1 },
  { id: 4, nom: "Cellule Plateau",   description: null, eglise_id: 2, eglise_nom: "Église Grâce Dakar",   responsable_id: null, responsable_nom: null, is_active: true, nb_membres: 1 },
  { id: 5, nom: "Cellule République",description: null, eglise_id: 3, eglise_nom: "Église Grâce Paris",   responsable_id: null, responsable_nom: null, is_active: true, nb_membres: 1 },
  { id: 6, nom: "Cellule Bastille",  description: null, eglise_id: 3, eglise_nom: "Église Grâce Paris",   responsable_id: null, responsable_nom: null, is_active: true, nb_membres: 1 },
  { id: 7, nom: "Cellule Nation",    description: null, eglise_id: 3, eglise_nom: "Église Grâce Paris",   responsable_id: null, responsable_nom: null, is_active: true, nb_membres: 1 },
];

export const MOCK_EGLISES = [
  { id: 1, nom: "Église Grâce Abidjan", ville: "Abidjan", pays: "Côte d'Ivoire", pasteur_principal: "Pasteur Emmanuel Koffi", nb_membres: 3 },
  { id: 2, nom: "Église Grâce Dakar",   ville: "Dakar",   pays: "Sénégal",        pasteur_principal: "Pasteur Mamadou Diop",   nb_membres: 2 },
  { id: 3, nom: "Église Grâce Paris",   ville: "Paris",   pays: "France",         pasteur_principal: "Pasteur J.-B. Mensah",   nb_membres: 3 },
];

export const MOCK_MEMBERS = [
  { id: 1, prenom: "Aïcha",        nom: "Bamba",     full_name: "Aïcha Bamba",        genre: "femme", email: "aicha.bamba@example.ci",  telephone: "+225 07 11 22 33 44", ville: "Abidjan", pays: "Côte d'Ivoire", statut: "actif",   departement: "Louange",      role_eglise: "Choriste",            cellule_id: 1, cellule_nom: "Cellule Cocody",    eglise_id: 1, profession: "Infirmière" },
  { id: 2, prenom: "Kouadio",      nom: "N'Guessan", full_name: "Kouadio N'Guessan",  genre: "homme", email: "kouadio.nguessan@example.ci", telephone: "+225 05 99 88 77 66", ville: "Abidjan", pays: "Côte d'Ivoire", statut: "actif",   departement: "Jeunesse",     role_eglise: "Diacre",              cellule_id: 2, cellule_nom: "Cellule Riviera",   eglise_id: 1, profession: "Ingénieur informatique" },
  { id: 3, prenom: "Fatou",        nom: "Traoré",    full_name: "Fatou Traoré",       genre: "femme", email: "fatou.traore@example.ci",     telephone: "+225 01 23 45 67 89", ville: "Abidjan", pays: "Côte d'Ivoire", statut: "nouveau", departement: "Intercession", role_eglise: null,                  cellule_id: 1, cellule_nom: "Cellule Cocody",    eglise_id: 1, profession: "Étudiante" },
  { id: 4, prenom: "Ibrahima",     nom: "Sow",       full_name: "Ibrahima Sow",       genre: "homme", email: "ibrahima.sow@example.sn",     telephone: "+221 77 555 12 34",   ville: "Dakar",   pays: "Sénégal",       statut: "actif",   departement: "Finances",     role_eglise: "Trésorier",           cellule_id: 3, cellule_nom: "Cellule Mermoz",    eglise_id: 2, profession: "Comptable" },
  { id: 5, prenom: "Awa",          nom: "Ndiaye",    full_name: "Awa Ndiaye",         genre: "femme", email: "awa.ndiaye@example.sn",       telephone: "+221 76 234 56 78",   ville: "Dakar",   pays: "Sénégal",       statut: "actif",   departement: "Enfants",      role_eglise: "Monitrice",           cellule_id: 4, cellule_nom: "Cellule Plateau",   eglise_id: 2, profession: "Enseignante" },
  { id: 6, prenom: "Marie-Claire", nom: "Mensah",    full_name: "Marie-Claire Mensah", genre: "femme", email: "mc.mensah@example.fr",       telephone: "+33 6 12 34 56 78",   ville: "Paris",   pays: "France",        statut: "actif",   departement: "Accueil",      role_eglise: "Responsable accueil", cellule_id: 5, cellule_nom: "Cellule République", eglise_id: 3, profession: "Médecin" },
  { id: 7, prenom: "David",        nom: "Kouassi",   full_name: "David Kouassi",      genre: "homme", email: "david.kouassi@example.fr",   telephone: "+33 7 89 12 34 56",   ville: "Paris",   pays: "France",        statut: "actif",   departement: "Média",        role_eglise: "Responsable son",     cellule_id: 6, cellule_nom: "Cellule Bastille",  eglise_id: 3, profession: "Développeur" },
  { id: 8, prenom: "Esther",       nom: "Boahen",    full_name: "Esther Boahen",      genre: "femme", email: "esther.boahen@example.fr",   telephone: "+33 6 55 44 33 22",   ville: "Paris",   pays: "France",        statut: "nouveau", departement: "Femmes",       role_eglise: null,                  cellule_id: 7, cellule_nom: "Cellule Nation",    eglise_id: 3, profession: "Avocate" },
];

/** Événements mock — utilisés en fallback si le backend est injoignable. */
export const MOCK_EVENTS = [
  { id: 1, titre: "Culte du dimanche",            type: "culte",      date_debut: "2026-05-03T10:00:00", date_fin: "2026-05-03T12:30:00", lieu: "Grande salle",          description: "Culte hebdomadaire avec sainte cène", eglise_id: 1 },
  { id: 2, titre: "Réunion de prière",            type: "reunion",    date_debut: "2026-05-05T19:30:00", date_fin: "2026-05-05T21:00:00", lieu: "Salle B",               description: "Veillée d'intercession",              eglise_id: 1 },
  { id: 3, titre: "École biblique - Jeunesse",    type: "formation",  date_debut: "2026-05-08T18:00:00", date_fin: "2026-05-08T20:00:00", lieu: "Salle des jeunes",      description: "Étude du livre des Romains",          eglise_id: 1 },
  { id: 4, titre: "Conférence Femmes de Foi",     type: "conference", date_debut: "2026-05-15T09:00:00", date_fin: "2026-05-16T17:00:00", lieu: "Auditorium Mermoz",     description: "Deux jours de conférence",            eglise_id: 2 },
  { id: 5, titre: "Sortie évangélisation",        type: "mission",    date_debut: "2026-05-22T08:00:00", date_fin: "2026-05-22T13:00:00", lieu: "Place de l'Indépendance", description: "Évangélisation centre-ville",       eglise_id: 2 },
  { id: 6, titre: "Baptêmes du semestre",         type: "bapteme",    date_debut: "2026-06-07T10:00:00", date_fin: "2026-06-07T13:00:00", lieu: "Plage de Bassam",       description: "Baptême par immersion",               eglise_id: 1 },
];

export const MOCK_DASHBOARD = {
  kpi: {
    total_membres: 8,
    nouveaux_membres_mois: 2,
    membres_actifs: 6,
    total_dons_mois: 1850,
    total_dons_annee: 18420,
    devise: "EUR",
    nb_eglises: 3,
    nb_evenements_a_venir: 4,
  },
  dons_mensuels: {
    title: "Évolution des dons (12 mois)",
    points: [
      { label: "Mai 25", value: 1250 },
      { label: "Jun 25", value: 1450 },
      { label: "Jul 25", value: 1620 },
      { label: "Aoû 25", value: 1380 },
      { label: "Sep 25", value: 1740 },
      { label: "Oct 25", value: 1820 },
      { label: "Nov 25", value: 1950 },
      { label: "Déc 25", value: 2180 },
      { label: "Jan 26", value: 1680 },
      { label: "Fév 26", value: 1720 },
      { label: "Mar 26", value: 1830 },
      { label: "Avr 26", value: 1850 },
    ],
  },
  repartition_dons: {
    title: "Répartition par type de don",
    points: [
      { label: "Dîme",     value: 9800 },
      { label: "Offrande", value: 5400 },
      { label: "Projet",   value: 2100 },
      { label: "Mission",  value: 1120 },
    ],
  },
  nouveaux_membres: {
    title: "Nouveaux membres (12 mois)",
    points: [
      { label: "Mai 25", value: 1 }, { label: "Jun 25", value: 0 },
      { label: "Jul 25", value: 2 }, { label: "Aoû 25", value: 1 },
      { label: "Sep 25", value: 0 }, { label: "Oct 25", value: 1 },
      { label: "Nov 25", value: 1 }, { label: "Déc 25", value: 0 },
      { label: "Jan 26", value: 1 }, { label: "Fév 26", value: 1 },
      { label: "Mar 26", value: 0 }, { label: "Avr 26", value: 0 },
    ],
  },
  repartition_membres: {
    title: "Répartition des membres par statut",
    points: [
      { label: "Actif",    value: 6 },
      { label: "Nouveau",  value: 2 },
      { label: "Inactif",  value: 0 },
      { label: "Visiteur", value: 0 },
    ],
  },
};

export const MOCK_DONS_BY_MEMBER = {
  1: [
    { id: 1, montant: 100, devise: "XOF", type_don: "dime",     methode: "mobile_money", date_don: "2026-04-05", description: "Dîme avril" },
    { id: 2, montant: 50,  devise: "XOF", type_don: "offrande", methode: "especes",      date_don: "2026-03-12", description: "Offrande" },
    { id: 3, montant: 100, devise: "XOF", type_don: "dime",     methode: "mobile_money", date_don: "2026-03-05", description: "Dîme mars" },
  ],
};

/** Retourne le user mock correspondant à un email/password. */
export function mockLogin(email, password) {
  if (email === "admin@monministere.com" && password === "admin123") {
    return { user: MOCK_USER_ADMIN, access_token: "mock-admin-access", refresh_token: "mock-admin-refresh", expires_in: 900 };
  }
  if (email === "fidele@monministere.com" && password === "fidele123") {
    return { user: MOCK_USER_FIDELE, access_token: "mock-fidele-access", refresh_token: "mock-fidele-refresh", expires_in: 900 };
  }
  return null;
}
